import type { RadioPropsType } from '@atpoint/atpjs/components/form/radio'
import { type ValuesType, createOptions } from '@atpoint/atpjs/components/form/values'
import { Component } from 'react'
import { InputSwitch } from 'swisscard/components/form'

export class InputGender extends Component<RadioPropsType> {
  values: ValuesType
  constructor(props: RadioPropsType) {
    super(props)
    this.values = createOptions(['genders'], ['male', 'female'])
  }
  render() {
    return <InputSwitch {...this.props} values={this.values} direction="horizontal" />
  }
}
